import React, {Component} from 'react';
import styles from './css-modules/gallery_section.module.css';

class GallerySection extends Component {
  render () {
    return (
      <div id={this.props.id} ref={this.props.addFadeRef} className={`${styles.gallerySection_container} ${this.props.margined && styles.margined_gallerySection}`}>
        {this.props.images.row1 && <div className={`${styles.gallery_row} ${this.props.increased_row_padding && styles.smaller_gallery_row}`}>
          {this.props.images.row1 && this.props.images.row1.length > 0 && this.props.images.row1.map((image, index) => (
            <div onClick={() => this.props.setDisplayedOverlay(image.oId)} key={index} className={styles.gallery_image_container}>
              <img alt="" className={`${styles.gallery_image} ${image.portrait && styles.portraitImage}`} src={image.image}></img>
            </div>
          ))}
        </div>}
        {this.props.images.row2 && <div className={`${styles.gallery_row} ${this.props.increased_row_padding && styles.smaller_gallery_row}`}>
          {this.props.images.row2 && this.props.images.row2.length > 0 && this.props.images.row2.map((image, index) => (
            <div onClick={() => this.props.setDisplayedOverlay(image.oId)} key={index} className={styles.gallery_image_container}>
              <img alt="" className={`${styles.gallery_image} ${image.portrait && styles.portraitImage}`} src={image.image}></img>
            </div>
          ))}
        </div>}
        {this.props.images.row3 && <div className={`${styles.gallery_row} ${this.props.increased_row_padding && styles.smaller_gallery_row}`}>
          {this.props.images.row3 && this.props.images.row3.length > 0 && this.props.images.row3.map((image, index) => (
            <div onClick={() => this.props.setDisplayedOverlay(image.oId)} key={index} className={styles.gallery_image_container}>
              <img alt="" className={`${styles.gallery_image} ${image.portrait && styles.portraitImage}`} src={image.image}></img>
            </div>
          ))}
        </div>}
      </div>
    )
  }
}

export default GallerySection;
